import api from "@/lib/api"
import { ROUTES } from "@/constants/routes"

export interface AuditEntry {
  id: number
  at: string
  action: string
  actor_user: number | null
  actor_label: string
  model: string | null
  app_label: string | null
  object_id: string
  object_repr: string
  changes: Record<string, any>
  request_method: string
  request_path: string
  request_ip: string | null
  correlation_id: string
}

export interface AuditListResponse {
  count: number
  entries: AuditEntry[]
}

export const AuditAPI = {
  async list(params: { action?: string; actor?: number; model?: string; q?: string; limit?: number } = {}): Promise<AuditListResponse> {
    const qs = new URLSearchParams()
    if (params.action) qs.set("action", params.action)
    if (params.actor) qs.set("actor", String(params.actor))
    if (params.model) qs.set("model", params.model)
    if (params.q) qs.set("q", params.q)
    if (params.limit) qs.set("limit", String(params.limit))
    const { data } = await api.get(`${ROUTES.API.AUDIT_ENTRIES}?${qs.toString()}`)
    return data
  },

  async restore(app: string, model: string, pk: number | string): Promise<{ ok: true; id: number }> {
    const { data } = await api.post(
      `${ROUTES.API.AUDIT_RESTORE}${app}/${model}/${pk}/`,
    )
    return data
  },
}
